import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { DatePickerField } from "./DatePickerField";
import { DynamicAttributeFields } from "./DynamicAttributeFields";
import type { CategoryWithSchema, EditAssetFormData } from "./types";

interface DateAndSpecFieldsProps {
  formData: EditAssetFormData;
  onFormChange: (updater: (prev: EditAssetFormData) => EditAssetFormData) => void;
  selectedCategory: CategoryWithSchema | undefined;
  dynamicAttributes: Record<string, any>;
  onDynamicAttributesChange: (updater: (prev: Record<string, any>) => Record<string, any>) => void;
}

export function DateAndSpecFields({
  formData,
  onFormChange,
  selectedCategory,
  dynamicAttributes,
  onDynamicAttributesChange,
}: DateAndSpecFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <DatePickerField
        label="Purchase Date"
        value={formData.purchase_date}
        onChange={(date) => onFormChange(prev => ({ ...prev, purchase_date: date }))}
      />

      <div className="space-y-2">
        <Label htmlFor="purchase_price">Purchase Price</Label>
        <Input
          id="purchase_price"
          type="number"
          step="0.01"
          value={formData.purchase_price}
          onChange={(e) => onFormChange(prev => ({ ...prev, purchase_price: e.target.value }))}
          placeholder="0.00"
        />
      </div>

      <DatePickerField
        label="Installation Date"
        value={formData.installation_date}
        onChange={(date) => onFormChange(prev => ({ ...prev, installation_date: date }))}
      />

      <DatePickerField
        label="Warranty Expires"
        value={formData.warranty_expires}
        onChange={(date) => onFormChange(prev => ({ ...prev, warranty_expires: date }))}
      />

      <DatePickerField
        label="Last Maintenance"
        value={formData.last_maintenance}
        onChange={(date) => onFormChange(prev => ({ ...prev, last_maintenance: date }))}
      />

      <DatePickerField
        label="Next Maintenance"
        value={formData.next_maintenance}
        onChange={(date) => onFormChange(prev => ({ ...prev, next_maintenance: date }))}
      />

      <DynamicAttributeFields
        category={selectedCategory}
        values={dynamicAttributes}
        onChange={onDynamicAttributesChange}
      />
    </div>
  );
}
